import React from 'react';
import { getRoutePermissions } from '../common/permissions';
import ResourceRequestsRedirect from './ResourceRequestsRedirect';
import ResourcingBadgeIcon from './ResourcingBadgeIcon';

export const hasPermission = ({ permissions }) =>
  Boolean(
    permissions.find(
      p =>
        p.permissionActionUri ===
        'urn:replicon:resource-assignment-action:view-resource-assignments'
    )
  );

const resourcingRoute = ({ intl, me, isMobile }) => {
  const { canViewResourcing } = getRoutePermissions(me);

  return {
    path: '/resourcing',
    icon: () => <ResourcingBadgeIcon />,
    isSideBarRoute: true,
    hidden:
      isMobile || me.featureFlags.isPsaPrpUnisysResourceManagementHiddenEnabled,
    showDivider: true,
    component: ResourceRequestsRedirect,
    title: () => intl.formatMessage({ id: 'routes.resourceAllocation' }),
    hasPermission: canViewResourcing
  };
};

export default resourcingRoute;
